import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

const includedCards = [
  {
    icon: <MenuBookOutlinedIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />, // Journal
    title: 'CYJ Self-Discovery Journal',
    desc: '65 pages of guided reflection, release, and rebuilding.'
  },
  {
    icon: <LibraryBooksOutlinedIcon sx={{ fontSize: 40, color: 'custom.red', mb: 1 }} />, // Guide
    title: 'CYJ Deep Guide',
    desc: '158 pages of step-by-step, science-based support and transformation.'
  },
  {
    icon: <AssessmentOutlinedIcon sx={{ fontSize: 40, color: 'custom.blue', mb: 1 }} />, // Assessments
    title: 'Personal Assessments',
    desc: 'Science-based insight into your strengths, wellbeing, and satisfaction.'
  },
];

const WhatsIncluded = () => (
  <Box sx={{ bgcolor: 'custom.blue', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'text.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        What’s Included in the CYJ Self-Discovery Package
      </Typography>
      <Grid container spacing={3} justifyContent="center" sx={{ mb: 4 }}>
        {includedCards.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Card elevation={3} sx={{ borderRadius: 3, p: 2, height: '100%', bgcolor: 'background.paper', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>{item.icon}</Box>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{item.title}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: 15 }}>{item.desc}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ bgcolor: 'custom.beige', borderRadius: 2, p: { xs: 2, md: 3 }, mb: 3 }}>
        <Typography variant="h6" sx={{ color: 'primary.main', mb: 1, fontWeight: 600 }}>
          Table of Contents Highlights
        </Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 15, mb: 1 }}>
          • Foundations of Positive Psychology: Happiness, Emotions, Hope, Resilience<br/>
          • 5 Powerful Modules: Who am I? My Aspirations, My Challenges, My Blessings & Affirmations, My Contribution & Life Purpose<br/>
          • The 12 Blueprints for Lasting Change
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default WhatsIncluded;
